import { forwardRef } from 'react';
import { Icon } from '@iconify/react';
import { Box, type BoxProps } from '@mui/material';

import { type IconifyProps } from './types'; // Adjust based on your imports

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  icon: IconifyProps;
  width?: number;
}

const Iconify = forwardRef<SVGElement, Props>(({ icon, width = 20, sx, ...other }, ref) => (
  <Box
    ref={ref}
    component="span"
    sx={{ width, height: width, display: 'inline-block', ...sx }}
    {...other}
  >
    <Icon icon={icon} width={width} height={width} />
  </Box>
));

export { Iconify };
